import React from 'react';
import styled from '@emotion/styled';

export type EightViewsMatrix = [
    [React.ReactNode | null, React.ReactNode | null, React.ReactNode | null],
    [React.ReactNode | null, React.ReactNode | null, React.ReactNode | null],
    [React.ReactNode | null, React.ReactNode | null]?
]

const Frame = styled.div({
    height: '100%',
    width: '100%',
    padding: '5px',
    boxSizing: 'border-box',

    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr min-content',
    rowGap: '5px',
});

const Upper = styled.div({
    height: 'auto',

    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '4fr 6fr',
    rowGap: '5px',
});

const Lower = styled.div<{ sideViews: boolean }>(props => ({
    display: 'grid',
    gridTemplateColumns: props.sideViews ? '1fr 5fr 1fr' : '1fr',
    columnGap: '5px',
}));

const TopLine = styled.div({
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 1fr',
    columnGap: '5px',
});

const CenterLine = styled.div({
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 1fr',
    columnGap: '5px',
});

const Cell = styled.div({
    height: '100%',
    width: '100%',
});

export type DriveModeLayoutProps = {
    views: EightViewsMatrix;
    controllerPanel: React.ReactNode;
}

export function DriveModeLayout(props: DriveModeLayoutProps) {
    const {
        views: [
            [backLeft, backCenter, backRight],
            [frontLeft, frontCenter, frontRight],
            interiorViews,
        ],
        controllerPanel,
    } = props;

    const [interiorLeft, interiorRight] = interiorViews ?? [];

    const eightViewsMode = (interiorLeft || interiorRight) ? true : false;

    return (
        <Frame>
            <Upper>
                <TopLine>
                    <Cell>{backLeft ?? <div />}</Cell>
                    <Cell>{backCenter ?? <div />}</Cell>
                    <Cell>{backRight ?? <div />}</Cell>
                </TopLine>
                <CenterLine>
                    <Cell>{frontLeft ?? <div />}</Cell>
                    <Cell>{frontCenter ?? <div />}</Cell>
                    <Cell>{frontRight ?? <div />}</Cell>
                </CenterLine>
            </Upper>
            <Lower sideViews={eightViewsMode}>
                {eightViewsMode
                    ? <React.Fragment>
                        <Cell> {interiorLeft ?? <div />}</Cell>
                        <Cell>{controllerPanel ?? <div />}</Cell>
                        <Cell>{interiorRight ?? <div />}</Cell>
                    </React.Fragment>
                    : <Cell>{controllerPanel ?? <div />}</Cell>
                }
            </Lower>
        </Frame >
    );
}
